import BusinessDocumentationSoftwareLayout from '../components/layouts/BusinessDocumentationSoftwareLayout.vue';
import BusinessDocumentationSoftwareIndexPage from '../pages/BusinessDocumentationSoftwareIndexPage.vue';
import BusinessSystemShowPage from '../pages/business-system/BusinessSystemShowPage.vue';
import AssetsShowPage from '../pages/business-system/assets/AssetsShowPage.vue';
import ChecklistTemplatesShowPage from '../pages/business-system/checklists/ChecklistTemplatesShowPage.vue';
import CredentialsShowPage from '../pages/business-system/credentials/CredentialsShowPage.vue';
import FaqsShowPage from '../pages/business-system/faqs/FaqsShowPage.vue';

import ProcedureEditPage from '../pages/business-system/procedures/ProcedureEditPage.vue';
import ProcedureShowPage from '../pages/business-system/procedures/ProcedureShowPage.vue';
import ProceduresShowPage from '../pages/business-system/procedures/ProceduresShowPage.vue';
import UsersShowPage from '../pages/business-system/users/UsersShowPage.vue';
import BusinessSystemOverviewPage from '../pages/business-system/BusinessSystemOverviewPage.vue'
import ChecklistTemplateShowPage from '../../../../checklists/resources/js/pages/ChecklistTemplateShowPage.vue'

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
  {
    // This is the parent route for your package.
    // It uses the layout component.
    path: '/business-documentation-software',
    name: 'business-documentation-software.root',
    component: BusinessDocumentationSoftwareLayout,
    meta: {
      // e.g., requiresAuth: true
      requiresAuth: true,
      title: 'businessDocumentationSoftware.nav.title',
      // layout: 'Authenticated',
    },
    // All other package routes are children of this layout
    children: [
      {
        // Child path is empty, so it renders at /business-documentation-software
        path: '',
        name: 'BusinessDocumentationSoftwareIndexPage',
        component: BusinessDocumentationSoftwareIndexPage,
      },
      {
        path: 'systems/:businessSystem',
        component: BusinessSystemShowPage,
        children: [
          {
            path: '',
            name: 'OverviewShowPage',
            component: BusinessSystemOverviewPage,
          },
          {
            path: 'procedures',
            name: 'ProceduresShowPage',
            component: ProceduresShowPage,
          },
          {
            path: 'procedures/:procedure',
            name: 'ProcedureShowPage',
            component: ProcedureShowPage,
          },
          {
            path: 'procedures/:procedure/edit',
            name: 'ProcedureEditPage',
            component: ProcedureEditPage,
          },
          {
            path: 'checklist-templates',
            name: 'ChecklistTemplatesShowPage',
            component: ChecklistTemplatesShowPage,
          },
          {
            path: 'checklist-templates/:checklistTemplateId',
            name: 'BdsChecklistTemplateShowPage',
            component: ChecklistTemplateShowPage,
          },
          {
            path: 'checklist-templates/:checklistTemplateId/edit',
            name: 'BdsChecklistTemplateEditPage',
            component: ChecklistTemplateShowPage,
          },
          {
            path: 'faqs',
            name: 'FaqsShowPage',
            component: FaqsShowPage,
          },
          {
            path: 'credentials',
            name: 'CredentialsShowPage',
            component: CredentialsShowPage,
          },
          {
            path: 'assets',
            name: 'AssetsShowPage',
            component: AssetsShowPage,
          },
          {
            path: 'users',
            name: 'UsersShowPage',
            component: UsersShowPage,
          },
        ],
      },
      // --- Example of other child routes ---
      // {
      //   path: 'create', // Renders at /business-documentation-software/create
      //   name: 'business-documentation-software.create',
      //   component: () => import('../components/Create.vue'),
      // },
    ]
  }
];
